'use strict';

const propTypes = require('prop-types');
const React = require( 'react' );
const { object, number, array, func } = propTypes;
const { GoogleMap, InfoWindow, withGoogleMap } = require( 'react-google-maps' );

const Map = withGoogleMap(props => (
  <GoogleMap
    ref={ ( map ) => ( props.mapRef( map )) }
    onClick={ props.click ? props.click : ( ) => {
      return false;
    } }
    defaultZoom={ props.defaultZoom || 10 }
    defaultCenter={ props.defaultCenter }
    options={{ clickableIcons: false, scrollwheel: false }}
  >
    { props.airportMarker }
    { props.markers }
    { props.infoWindow && props.infoWindow.content && (
      <InfoWindow
        onCloseclick={ props.infoWindow.onCloseclick }
        position={ props.infoWindow.position }
        zIndex={ 10000 }
      >
        { props.infoWindow.content }
      </InfoWindow>
    ) }
    { props.mapDirections }
    { props.productInfoButton }
  </GoogleMap>
));

Map.defaultProps = {
  containerElement: <div id="theMap" style={{ height: '400px' }} />,
  mapElement: <div style={{ height: '100%' }} />
}

Map.propTypes = {
  defaultZoom: number,
  defaultCenter: object,
  airportMarker: object,
  markers: array,
  infoWindow: object,
  mapDirections: object,
  productInfoButton: object,
  click: func,
  containerElement: object,
  mapElement: object
};

module.exports = Map;


// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/map/googleMap.jsx